import { LoginInfo } from "vue-glcommonui";
import { ActionTree } from "vuex";
import { AuthState } from "./state";
import { MODULES, vuexName } from "../utils";

const actions: ActionTree<AuthState, any> = {
  signin(store, payload: { loginInfo: LoginInfo }) {
    store.commit(vuexName(MODULES.AUTH.COMMITS.SET_LOGIN_INFO, false), payload.loginInfo);
  },
  signout(store, _) {
    store.commit(vuexName(MODULES.AUTH.COMMITS.SET_LOGIN_INFO, false), null);
  },
};

export default actions;
